import { Injectable } from '@angular/core';

import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import {
    VatCodeGridObject, VatCodeObject,
} from '@libs/types/src/mado/object-type/organization';
import { filterFrag } from './types/filter.types';
import { VatCodeCreateInput, VatCodeUpdateInput } from '@libs/types/src/mado/input-type/organization';

@Injectable({ providedIn: 'root' })
export class VatCodeGqlService extends GqlServiceV2 {

    public getVatCodes(input: GridInput | null, frag: string) {
        return this.query<VatCodeGridObject>(
            `
                query($input: GridInput!) {
                    vatCode {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createVatCode(input: VatCodeCreateInput, frag: string) {
        return this.mutate<VatCodeObject>(
            `
                mutation($input: VatCodeCreateInput!) {
                    vatCode {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateVatCode(input: VatCodeUpdateInput, frag: string) {
        return this.mutate<VatCodeObject>(
            `
                mutation($input: VatCodeUpdateInput!) {
                    vatCode {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
